// synced from loomweb blocks/text-block-view.tsx (de-Tailwind'd).
/**
 * Text block: renders `TextBlock.content` as markdown. Faithful to loomweb's
 * TextBlockView (markdown via react-markdown), without the streaming-cursor /
 * repeat-badge UI (replay is a finished session, never streaming). The markdown
 * component map lives in ReplayMarkdown.
 */
import type { JSX } from "react";
import type { TextBlock } from "@shared/loom-message-block";
import { ReplayMarkdown } from "./replay-markdown";

export function TextBlockView({ block }: { block: TextBlock }): JSX.Element {
  return (
    <div className="replay-text-block">
      <ReplayMarkdown>{block.content}</ReplayMarkdown>
    </div>
  );
}
